import axios from "axios";


console.log(process.env.REACT_APP_API_EXPERIENCE_URL)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_EXPERIENCE_URL,
  responseType: "json",
});



export default api;
